import { render } from "./TheDemandServiceIndexAndReservations.vue?vue&type=template&id=55d43ef2&scoped=true"
import script from "./TheDemandServiceIndexAndReservations.vue?vue&type=script&lang=js"
export * from "./TheDemandServiceIndexAndReservations.vue?vue&type=script&lang=js"

import "./TheDemandServiceIndexAndReservations.vue?vue&type=style&index=0&id=55d43ef2&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-55d43ef2"

export default script